module.exports = __webpack_public_path__ + "img/52.fbff8b23.jpg";